let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("akVf8")).then(() => parcelRequire('iUU9u'));